export const LinkConstants = {
  RESEARCH_TOOL: "https://research.mlb.com/games/"
};
